import { BaseWebApiDAO } from './BaseWebApiDAO';
import { BaseService } from '../Service/BaseService';
import { AppSettingApi } from '../AppSettingApi';

export class PostCodeDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}

	/**
	 * 郵便番号から住所を取得
	 * @param postCode
	 */
	public async getAddress(postCode: string): Promise<{
		prefecture: string;
		city: string;
	}> {

		const request = {
			post_code: postCode
		};

		const ret = await this.postRequest(AppSettingApi.ADDRESS_GET, request);
		return ret;

	}

}

